import React from 'react';

const HeadlineLarge = ({ text }) => {
  return <h2 className='headline__large'>{text}</h2>;
};

export default HeadlineLarge;
